import React from 'react'
import OfferListDataTable from '../../components/common/OfferList';

const OfferList = () => {
  return (
    <OfferListDataTable />
  )
}

export default OfferList;